import React from 'react';
import { AppState } from '../../../../types/store';
import { connect } from 'react-redux';
import { getModuleConfig } from '../../../selectors/modules';
import { fetchModuleConfig, saveModuleConfig } from '../../../actions/modules';
import { branch } from 'recompose';
import ChunkLoadingPopover from '../_partials/ChunkLoadingPopover';

export interface WithModuleConfigProps {
  moduleConfig?: {
    config: any;
    options?: any;
  };
  fetchModuleConfig?: () => void;
  saveModuleConfig?: (payload: any) => void;
}

export const withModuleConfig = <BaseProps extends WithModuleConfigProps>(
  BaseComponent: React.ComponentType<BaseProps>
) => {
  const mapStateToProps = (state: AppState, ownProps) => {
    const moduleConfig = getModuleConfig(state, ownProps.moduleId);
    // getModuleConfig returns an empty object if no config is found in the store
    // but we want it to be undefined, since it's easier to check if the
    // variable is undefined than it is to check whether the object has any keys
    const isModuleConfigEmpty = Object.keys(moduleConfig).length === 0;
    return {
      moduleConfig: isModuleConfigEmpty ? undefined : moduleConfig,
    };
  };

  const mapDispatchToProps = (dispatch, ownProps) => {
    const { moduleId } = ownProps;
    return {
      saveModuleConfig: (payload: any) =>
        dispatch(saveModuleConfig({ ...payload, moduleId })),
      fetchModuleConfig: () => dispatch(fetchModuleConfig({ moduleId })),
    };
  };

  type HocProps = ReturnType<typeof mapStateToProps> &
    ReturnType<typeof mapDispatchToProps>;

  class ComponentWithModuleConfig extends React.Component<HocProps> {
    componentDidMount() {
      const {
        moduleConfig = false,
        fetchModuleConfig: fetchConfig,
      } = this.props;
      if (!moduleConfig) {
        // This is the first time we're showing this form
        // we need to lazy load the config data
        fetchConfig && fetchConfig();
      }
    }
    render() {
      return <BaseComponent {...(this.props as BaseProps)} />;
    }
  }

  return connect(
    mapStateToProps,
    mapDispatchToProps
  )(ComponentWithModuleConfig);
};

export const withWaitForModuleConfig = branch(
  props => !props.moduleConfig,
  () => ChunkLoadingPopover
);

export default withModuleConfig;
